import React, { useState } from "react";
import { Button, Form, Row, Col, Image } from "react-bootstrap";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { SliderReusableComponent } from "../../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import SVG from "react-inlinesvg";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Scrollbars from "react-custom-scrollbars";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

export const EditCategories = () => {
  const [file, setFile] = useState(null);
  const [WithTaxes, setWithTaxe] = useState(false);
  const [active, setActive] = useState(1);
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [keywords, setKeywords] = useState([]);
  const [keywordsText, setKeywordsText] = useState("");
  const uploadImage = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
  };
  const handleWithTaxes = () => {
    setWithTaxe({
      WithTaxes: !WithTaxes.WithTaxes,
    });
  };
  const handleTextPORV = (e) => {
    setActive(e);
  };
  const handleNextStep = (e) => {
    setStep(e);
  };
  /*******************************
   * Add Keywords Action
   ******************************/
  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === "") {
      errors.keywordsTextVr = "Keywords is Required";
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert("Keywords Already Exits");
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText("");
    }
  };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };
  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="mobile-pb-70 p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
          >
            <Media query="(min-width: 992px)">
              <div className="col-12">
              <BackLogoIconButton
                displayBackText={true}
                displayArrow={true}
                backButtonClicked={
                  "/casual-fine-dining/menusetup/selectmenu/categorytype"
                }
                notDisplaProgressBar={true}
                />
              </div>
            </Media>
            <Media query="(max-width: 991px)">
              <MobileTopHeader
                link={true}
                onLink={"/casual-fine-dining/menusetup/selectmenu/categorytype"}
              />
            </Media>
            <div className="onboarding_process_screen-button-map">
              <div className="mb-4">
                <TopTextReusableComponent
                  headingText="Edit Category Details"
                  headingParagraph="Edit the category details and update"
                />
              </div>
              <Form>
                {step === 1 && (
                  <React.Fragment>
                    <div className="nav-scroller mb-4">
                      <ul
                        className="enStepNav nav list-unstyled d-flex justify-content-between"
                        style={{ width: 300 }}
                      >
                        <li className="doing">
                          <div className="stepNumber">01</div>
                          <div className="text">Define Category</div>
                        </li>
                        <li className="todo">
                          <div className="stepNumber">02</div>
                          <div className="text">Taxes & Other Details</div>
                        </li>
                      </ul>
                    </div>
                    <Form.Label className="f14-500 mb-3">
                      Edit Menu Category
                    </Form.Label>
                    <Row>
                      <Col md={8}>
                        <NewInputText
                          labelText="Category Name"
                          extraClass="mb-3 w-100"
                        />
                      </Col>
                      <Col md={8} className="mt-3">
                        <div className=" onboarding-restaurant-details-margin">
                          <div className="row align-items-center">
                            <div className="col-7">
                              <NewInputText
                                extraClass="mb-0"
                                name="keywordsText"
                                onChange={onKeywordsChangeHandler}
                                value={keywordsText}
                                labelText="Keywords"
                              />
                              <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                                {errors.keywordsText}
                              </div>
                            </div>
                            <div className="col-5">
                              <AddButtonIconComponent
                                buttonText="Add More Keywords"
                                onClick={addKeywordsAction}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col md={8} className="mt-3">
                        <div className="col-12 p-0 onboarding-restaurant-details-margin">
                          <div className="enChipBox">
                            <Scrollbars style={{ width: "100%", height: 135 }}>
                              {keywords &&
                                keywords.map((data, index) => {
                                  return (
                                    <div className="mb-3 mr-3" key={index}>
                                      <div className="keywords_button">
                                        <p>{data}</p>
                                        <span
                                          className="ml-2"
                                          onClick={removeKeywordsAction(index)}
                                        >
                                          <SVG
                                            src={require("../../../../../../../../assets/images/UserManagement/close.svg")}
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })}
                            </Scrollbars>
                          </div>
                          <div className="opacity5 f10-400">
                            * Manage the utterances for the Categories
                          </div>
                        </div>
                      </Col>
                      <Col md={4} className="mt-3">
                        <Button variant="danger">
                          <SVG
                            src={require("../../../../../../../../assets/images/UserManagement/microphone.svg")}
                            width="22px"
                            height="30px"
                          />
                        </Button>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col md={8}>
                        <NewInputText
                          labelText="Category Description"
                          extraClass="mb-3 w-100"
                          multiline={true}
                          rows="4"
                        />
                      </Col>
                    </Row>
                    <Form.Label className="f14-500 mb-1">Add Photos</Form.Label>
                    <div className="d-flex flex-wrap">
                      <div className="enUploadBox">
                        <Image
                          src={require("../../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={uploadImage}
                        />
                      </div>
                      {file && (
                        <div className="enIconUploaded">
                          <button
                            type="button"
                            className="enCloseButton"
                            onClick={() => setFile(null)}
                          >
                            <Image
                              src={require("../../../../../../../../assets/images/UserManagement/en_close.svg")}
                              alt="uploadImg"
                              title="uploadImg"
                              fluid
                            />
                          </button>
                          <Image
                            src={file}
                            alt="icon"
                            title="icon"
                            className=""
                            fluid
                          />
                        </div>
                      )}
                    </div>
                    <hr />
                    <Form.Label className="f14-500 mb-3">
                      Category Classification
                    </Form.Label>
                    <div className="justify-content-start column-2 d-flex align-items-center">
                      <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Soups"
                            />

                            <span className="para-data-icon">Soups</span>
                          </div>
                        </div>
                      </div>
                      <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Starters"
                            />

                            <span className="para-data-icon">Starters</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Form.Label className="f14-500 my-3">
                      Product Classification
                    </Form.Label>
                    <Row>
                      <Col md={3} xs={6}>
                        <label className="enRadioWithText small f12-400 w-100 mb-3">
                          Food
                          <input type="radio" name="ProductClassification" />
                          <span className="checkmark"></span>
                        </label>
                      </Col>
                      <Col md={3} xs={6}>
                        <label className="enRadioWithText small f12-400 w-100 mb-3">
                          Beverage
                          <input type="radio" name="ProductClassification" />
                          <span className="checkmark"></span>
                        </label>
                      </Col>
                      <Col md={3} xs={6}>
                        <label className="enRadioWithText small f12-400 w-100 mb-3">
                          Alcohol
                          <input type="radio" name="ProductClassification" />
                          <span className="checkmark"></span>
                        </label>
                      </Col>
                      <Col md={3} xs={6}>
                        <label className="enRadioWithText small f12-400 w-100 mb-3">
                          Snack
                          <input type="radio" name="ProductClassification" />
                          <span className="checkmark"></span>
                        </label>
                      </Col>
                      <Col md={3} xs={6}>
                        <label className="enRadioWithText small f12-400 w-100 mb-3">
                          Product
                          <input type="radio" name="ProductClassification" />
                          <span className="checkmark"></span>
                        </label>
                      </Col>
                      <Col md={3} xs={6}>
                        <label className="enRadioWithText small f12-400 w-100 mb-3">
                          Service
                          <input type="radio" name="ProductClassification" />
                          <span className="checkmark"></span>
                        </label>
                      </Col>
                      <Col md={3} xs={6}>
                        <label className="enRadioWithText small f12-400 w-100 mb-3">
                          Other
                          <input type="radio" name="ProductClassification" />
                          <span className="checkmark"></span>
                        </label>
                      </Col>
                    </Row>
                    <div className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                      <div>
                        <ReusableOnboardingLink
                          buttonTitle="Back Button"
                          buttonClass="btn-lg btn btn-outline-secondary"
                          buttonText="Cancel"
                          link="/subscription"
                        />
                        <ReusableOnboardingButton
                          buttonTitle="Next Button"
                          buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                          buttonText="Next"
                          buttonType="Submit"
                          onClick={() => handleNextStep(2)}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
                {step === 2 && (
                  <React.Fragment>
                    <div className="nav-scroller mb-4">
                      <ul
                        className="enStepNav nav list-unstyled d-flex justify-content-between"
                        style={{ width: 300 }}
                      >
                        <li className="pho_24_medium done">
                          <div className="stepNumber">01</div>
                          <div className="text">Define Category</div>
                        </li>
                        <li className="doing">
                          <div className="stepNumber">02</div>
                          <div className="text">Taxes & Other Details</div>
                        </li>
                      </ul>
                    </div>
                    <Row>
                      <Col md={8}>
                        <NewInputText
                          labelText="Category Name"
                          extraClass="mb-3 w-100"
                        />
                      </Col>
                    </Row>
                    <Form.Label className="f16-500 my-3">
                      Taxes & Other CHarges
                    </Form.Label>
                    <Row className="align-items-center py-3">
                      <Col xs={6}>
                        <div className="f14-700">Price Includes Taxes</div>
                        <div className="f11-400 opacity5">
                          (Taxes are same for all the items in the category)
                        </div>
                      </Col>
                      <Col xs={6}>
                        <ToggleButtonWithYesNo
                          activeClass={WithTaxes.WithTaxes}
                          checkedBox={WithTaxes.WithTaxes}
                          onChange={handleWithTaxes}
                        />
                      </Col>
                    </Row>
                    <hr />
                    <Row className="align-items-center py-3">
                      <Col xs={6}>
                        <div className="f14-700">Taxability</div>
                        <div className="f11-400 opacity5">
                          (Taxes are same for all the items in the category)
                        </div>
                      </Col>
                      <Col xs={6}>
                        <ToggleButtonWithYesNo
                          activeClass={WithTaxes.WithTaxes}
                          checkedBox={WithTaxes.WithTaxes}
                          onChange={handleWithTaxes}
                        />
                        <div className="w-100">
                          <div className="enFiledWith2Btn">
                            <input
                              type="text"
                              placeholder="% or Value"
                              className="f12-400"
                            />
                            <div className="btnGroup">
                              <button
                                type="button"
                                onClick={() => handleTextPORV(1)}
                                className={`${active === 1 ? "active" : ""}`}
                              >
                                %
                              </button>
                              <button
                                type="button"
                                onClick={() => handleTextPORV(2)}
                                className={`${active === 2 ? "active" : ""}`}
                              >
                                ₹
                              </button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="align-items-center py-3">
                      <Col xs={6}>
                        <div className="f14-700">Packaging Charges</div>
                        <div className="f11-400 opacity5">
                          (Packaging Charges are same for all the items in the
                          category)
                        </div>
                      </Col>
                      <Col xs={6}>
                        <ToggleButtonWithYesNo
                          activeClass={WithTaxes.WithTaxes}
                          checkedBox={WithTaxes.WithTaxes}
                          onChange={handleWithTaxes}
                        />
                        <div className="w-100">
                          <div className="enFiledWith2Btn">
                            <input
                              type="text"
                              placeholder="% or Value"
                              className="f12-400"
                            />
                            <div className="btnGroup">
                              <button
                                type="button"
                                onClick={() => handleTextPORV(1)}
                                className={`${active === 1 ? "active" : ""}`}
                              >
                                %
                              </button>
                              <button
                                type="button"
                                onClick={() => handleTextPORV(2)}
                                className={`${active === 2 ? "active" : ""}`}
                              >
                                ₹
                              </button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="align-items-center py-3">
                      <Col xs={6}>
                        <div className="f14-700">Surcharges</div>
                        <div className="f11-400 opacity5">
                          (Any Additional Surcharges same for all items in this
                          category)
                        </div>
                      </Col>
                      <Col xs={6}>
                        <ToggleButtonWithYesNo
                          activeClass={WithTaxes.WithTaxes}
                          checkedBox={WithTaxes.WithTaxes}
                          onChange={handleWithTaxes}
                        />
                        <div className="w-100">
                          <div className="enFiledWith2Btn">
                            <input
                              type="text"
                              placeholder="% or Value"
                              className="f12-400"
                            />
                            <div className="btnGroup">
                              <button
                                type="button"
                                onClick={() => handleTextPORV(1)}
                                className={`${active === 1 ? "active" : ""}`}
                              >
                                %
                              </button>
                              <button
                                type="button"
                                onClick={() => handleTextPORV(2)}
                                className={`${active === 2 ? "active" : ""}`}
                              >
                                ₹
                              </button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="mb-4">
                      <AddButtonIconComponent
                        buttonText="Add Another Surcharge"
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    </div>
                    <Row>
                      <Col xs={10} md={8}>
                        <NewInputText
                          labelText="Surcharge Name"
                          extraClass="mb-3 w-100"
                        />
                      </Col>

                      <Media query="(min-width:768px)">
                        <>
                          <Col md={2} className="pt-2">
                            <AddButtonIconComponent
                              buttonText="Add"
                              buttonType="button"
                              // onClick={formikCustom.handleSubmit}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </Col>

                          <Col xs={2} md={4} className="pt-2">
                            <AddButtonIconComponent
                              buttonText="Delete"
                              fontIcon="fa fa-trash-o"
                              colorCss="delete"
                            />
                          </Col>
                        </>
                      </Media>
                      <Media query="(max-width: 767px)">
                        <Col xs={2} className="pl-0">
                          <AddButtonIconComponent
                            buttonText="Add"
                            buttonType="button"
                            // onClick={formikCustom.handleSubmit}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                          <div className="pt-2">
                            <Button
                              variant="link"
                              className="p-0"
                              // onClick={(e) => deleteCustomSurcharge(e)}
                            >
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="Delete"
                                title="Delete"
                                fluid
                              />
                            </Button>
                          </div>
                        </Col>
                      </Media>
                      <Col xs={12} md={8}>
                        <Row className="pt-2">
                          <Col xs={6}>
                            <div className="enFiledWith2Btn m-0">
                              <input
                                type="text"
                                placeholder="% or Value"
                                className="f12-400"
                              />
                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV(1)}
                                  className={`${active === 1 ? "active" : ""}`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV(2)}
                                  className={`${active === 2 ? "active" : ""}`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <NewInputText
                              labelText="Description"
                              extraClass="mb-3 w-100"
                              multiline={true}
                              rows="4"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <div className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                      <div>
                        <ReusableOnboardingButton
                          buttonTitle="Back Button"
                          buttonClass="btn-lg btn btn-outline-secondary"
                          buttonText="Cancel"
                          onClick={() => handleNextStep(1)}
                        />
                        <ReusableOnboardingButton
                          buttonTitle="Next Button"
                          buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                          buttonText="Save"
                          buttonType="Submit"
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </Form>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              // displayBarButton={false}
              displayHamburger={true}
              headingText={"Menu Set Up - Categories"}
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
